import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { AuthService } from "src/app/auth/auth.service";
import { Dossier } from "../shared/models/dossier.model";
import { OperationType } from "../shared/models/user.model";

@Directive({  
  // tslint:disable-next-line: directive-selector
  selector: "[screenResource]",
})
export class ScreenResourceDirective implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  private screenType: string;
  private operationType: keyof typeof OperationType;
  private dossier: Dossier;

  @Input() set screenResource(type: any[]) {
    this.screenType = type[0];
    this.operationType = type[1];

    if (type.length > 2) {
      this.dossier = type[2];
    }

    this.updateView();
  }

  @Input() set screenResourceOperation(type: keyof typeof OperationType) {
    this.operationType = type;
  }

  private isHidden = true;

  constructor(private authService: AuthService, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private updateView(): void {
    this.subscriptions.push(this.checkPermission().subscribe(isAllowed => {
      if (isAllowed) {
        if (this.isHidden) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.isHidden = false;
        }
      } else {
        this.isHidden = true;
        this.viewContainer.clear();
      }
    }));
  }

  private checkPermission(): Observable<boolean> {
    if (this.dossier) {
      return this.authService.hasScreenResourceWithDossier(this.screenType, OperationType[this.operationType], this.dossier);
    } else {
      return this.authService.hasScreenResource(this.screenType, OperationType[this.operationType]);
    }
  }
}

@Directive({  
  // tslint:disable-next-line: directive-selector
  selector: "[reportResource]",
})
export class ReportResourceDirective implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  private report: string;

  @Input() set reportResource(type: any[]) {
    this.report = type[0];

    this.updateView();
  }

  private isHidden = true;

  constructor(private authService: AuthService, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private updateView(): void {
    this.subscriptions.push(this.checkPermission().subscribe(isAllowed => {
      if (isAllowed) {
        if (this.isHidden) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.isHidden = false;
        }
      } else {
        this.isHidden = true;
        this.viewContainer.clear();
      }
    }));
  }

  private checkPermission(): Observable<boolean> {
    return this.authService.hasReportResource(this.report);
  }
}
